// ============================================================
// changelog.js — Journal des nouveautés (lu par le modal "Quoi de neuf ?")
// ============================================================
//
// À CHAQUE déploiement front qui apporte un changement VISIBLE pour le client :
//   1. Ajouter une nouvelle entrée EN TÊTE du tableau CHANGELOG ci-dessous.
//   2. Mettre APP_VERSION = la `version` de cette nouvelle entrée.
//   3. Bumper aussi CACHE_VERSION dans public/service-worker.js
//      (compteur indépendant : il invalide le cache PWA).
//
// Comment ça marche pour le client :
//   - Après une mise à jour, l'appli compare APP_VERSION à la dernière
//     version qu'il a déjà vue (mémorisée localement).
//   - Si c'est différent, le modal "Nouveautés" s'ouvre automatiquement
//     avec la liste des changements. Il peut le lire puis le fermer.
//   - Il peut le rouvrir à tout moment via "Quoi de neuf ?" en pied de page.
//
// Format d'une entrée :
//   { version: 'AAAA.MM.JJ', date: 'libellé lisible', titre: '...',
//     items: ['phrase courte', ...] }
// Les `items` sont écrits POUR LE CLIENT (pas de jargon technique).
// ============================================================

export const APP_VERSION = '2026.06.25.2';

export const CHANGELOG = [
  {
    version: '2026.06.25.2',
    date: '25 juin 2026',
    titre: 'Double authentification (2FA)',
    items: [
      'Vous pouvez désormais sécuriser votre compte avec la double authentification, depuis « Mon profil » : un code à usage unique, généré par une application d’authentification (Google Authenticator, Authy…), s’ajoute à votre mot de passe à la connexion.',
      'À l’activation, des codes de secours vous sont fournis (à conserver) pour vous connecter si vous perdez votre téléphone.',
      'En cas de blocage, un administrateur peut réinitialiser votre double authentification. La 2FA reste optionnelle : vous l’activez si vous le souhaitez.',
    ],
  },
  {
    version: '2026.06.25.1',
    date: '25 juin 2026',
    titre: 'Sécurité et mises à jour',
    items: [
      'Déconnexion automatique après une période d’inactivité, pour protéger votre compte si l’écran reste ouvert sans surveillance (5 minutes pour l’administrateur, 15 minutes pour les autres comptes).',
      'Notification automatique de nouvelle version : un bandeau vous propose de mettre à jour l’application quand cela vous arrange.',
      'Ce panneau « Nouveautés » : après chaque mise à jour, vous pouvez lire en clair ce qui a changé. Vous pouvez le rouvrir à tout moment via « Quoi de neuf ? » en bas de page.',
    ],
  },
  {
    version: '2026.06.25',
    date: '25 juin 2026',
    titre: 'Lisibilité, impression et confort',
    items: [
      'Les montants se regroupent automatiquement par 3 chiffres pendant la saisie — plus facile à lire, moins d’erreurs.',
      'Choix du format à chaque impression : feuille A4 ou rouleau thermique (reçus, factures, bons de sortie et bons de commande).',
      'Page « Approvisionnement / Commande » : nouvelles colonnes Prix unitaire et Produit(s), et chaque ligne se déplie pour voir le détail produit par produit.',
      'Vous pouvez corriger un approvisionnement déjà enregistré : le stock et le prix d’achat moyen sont recalculés automatiquement.',
      'Lors d’une commande ou d’un approvisionnement, le dernier prix d’achat du produit est pré-rempli (et reste modifiable).',
      'Alerte quand un prix de vente est inférieur ou égal au prix d’achat (le contrôle de marge s’active/désactive dans Paramètres).',
    ],
  },
];

// ── Helpers ────────────────────────────────────────────────────────────────

// Renvoie les entrées plus récentes que la version déjà vue par le client.
// - versionVue inconnue ou absente → on renvoie seulement la dernière entrée
//   (on évite de noyer le client sous tout l'historique).
// - sinon → toutes les entrées ajoutées depuis sa dernière visite.
export function nouveautesDepuis(versionVue) {
  if (!versionVue) return CHANGELOG.slice(0, 1);
  const idx = CHANGELOG.findIndex((e) => e.version === versionVue);
  if (idx === -1) return CHANGELOG.slice(0, 1);
  return CHANGELOG.slice(0, idx); // tout ce qui précède la version vue
}
